const formatToWaveLength = (dataSetter) => {
    dataSetter((prevData) => ({
        ...prevData,
        headers: prevData?.headers
            ? [...prevData?.headers?.map((wn) => 10 ** 7 / wn)]
            : [],
    }));
};

const formatToAbsorbance = (isReflectance, dataSetter) => {
    if (isReflectance)
        dataSetter((prevData) => ({
            ...prevData,
            rows: prevData?.rows
                ? [
                      ...prevData?.rows?.map((arr) =>
                          arr.map((elem) =>
                              !isNaN(elem) ? Math.pow(10, -+elem) * 100 : elem
                          )
                      ),
                  ]
                : [],
        }));
    else {
        dataSetter((prevData) => ({
            ...prevData,
            rows: prevData?.rows
                ? [
                      ...prevData?.rows?.map((arr) =>
                          arr.map((elem) =>
                              !isNaN(elem) ? -Math.log10(+elem / 100) : elem
                          )
                      ),
                  ]
                : [],
        }));
    }
};

export { formatToWaveLength, formatToAbsorbance };
